import styled, { css } from 'styled-components';
import { mapping } from './assets';

export type IconType = keyof typeof mapping;

export interface ShadowIconProps {
  shadowColor?: string;
}

export interface IconProps {
  glyph: IconType;
  size?: number;
  color?: string;
}

const Icon = styled.div<IconProps>`
  width: ${({ size }) => size || 24}px;
  height: ${({ size }) => size || 24}px;
  ${({ glyph, color }) => {
    if (color) {
      return css`
        background-color: ${color};
        mask: url(${mapping[glyph]});
        mask-repeat: no-repeat;
        mask-size: contain;
        transition: 0.3s ease-out;
      `;
    }
    
    return css`
      background-image: url(${mapping[glyph]});
      background-size: contain;
      background-position: center center;
    `;
  }};
`;

const ShadowIcon = styled(Icon)<ShadowIconProps>`
  box-shadow: ${({ shadowColor }) => `0 6px 12px ${shadowColor}`};
`;

export { Icon, ShadowIcon };
